// extracted by mini-css-extract-plugin
export default {"helperString":"y8HLGWobdAyoL5MMmLqU","placeHolderShimmer":"O0SwX0GbOws8wDr4T5nl"};